import type { MultiSelectItemProps } from '@placer-ui/components';
import {
    supportStatusCategories,
    supportRequestsTypes,
} from 'features/offline-reports/support-requests/consts';

export const areSupportRequestsFiltered = (statusesCount: number, typesCount: number) => {
    if (
        (!statusesCount || statusesCount === Object.keys(supportStatusCategories).length) &&
        (!typesCount || typesCount === supportRequestsTypes.length)
    ) {
        return false;
    }

    return true;
};

export const getFilterTagValue = (statuses: MultiSelectItemProps[]) => {
    const selectedValues = statuses.filter(({ isSelected }) => isSelected);

    if (selectedValues.length === 0 || selectedValues.length === statuses.length) {
        return 'All';
    }

    const multipleTagValue = selectedValues.map((status) => status.label).join(', ');

    return selectedValues.length > 1 ? multipleTagValue : (selectedValues[0].label as string);
};

export const supportDateFormatter = (value: string, includeTime = true) => {
    if (!value) {
        return '';
    }

    const dateFormat = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        ...(includeTime
            ? {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
              }
            : {}),
    });

    return dateFormat.format(new Date(value));
};

export const convertSupportStatus = (status: string) => {
    if (supportStatusCategories.inProgress.includes(status)) {
        return 'In Progress';
    } else if (supportStatusCategories.completed.includes(status)) {
        return 'Completed';
    } else if (status === 'Pending') {
        return 'Pending Reply';
    }

    return status;
};

export const isDataTrustRequest = (supportTeam: string) => supportTeam === 'Data Quality';
